import { Trans } from "react-i18next";
import { Alert } from "antd";
import { observer } from "mobx-react-lite";

import { userStore } from "../../stores/userStore";

import "./SupportInfoAlert.css";

export const SupportInfoAlert = observer(function SupportInfoAlert() {
  const variant = userStore.isRuRegion ? "support.infoRu" : "support.infoInt";
  const termsUrl = userStore.isRuRegion
    ? "https://nextgis.ru/terms-support/"
    : "https://nextgis.com/terms-support/";
  const docsUrl = userStore.isRuRegion
    ? "https://docs.nextgis.ru/"
    : "https://docs.nextgis.com/";

  return (
    <Alert
      className="support-info-alert"
      type="info"
      showIcon
      style={{ alignItems: "flex-start" }}
      description={
        <div>
          <p>
            <Trans
              i18nKey={`${variant}.termsNote`}
              components={{
                termslink: (
                  <a href={termsUrl} target="_blank" rel="noreferrer" />
                ),
              }}
            />
          </p>
          <p style={{ paddingTop: 12 }}>
            <Trans
              i18nKey={`${variant}.resourcesNote`}
              components={{
                forumlink: (
                  <a
                    href="https://community.nextgis.com/"
                    target="_blank"
                    rel="noreferrer"
                  />
                ),
                telegramlink: (
                  <a
                    href="https://t.me/nextgis_chat"
                    target="_blank"
                    rel="noreferrer"
                  />
                ),
                maxlink: (
                  <a
                    href="https://max.ru/join/AJubGPmRXNy7LwoRSLf9Bc2b3nkY391kWt1YUF7Lo5Q"
                    target="_blank"
                    rel="noreferrer"
                  />
                ),
                docslink: <a href={docsUrl} target="_blank" rel="noreferrer" />,
                youtubelink: (
                  <a
                    href="https://www.youtube.com/@nextgis_channel"
                    target="_blank"
                    rel="noreferrer"
                  />
                ),
                rutubelink: (
                  <a
                    href="https://rutube.ru/u/nextgis/"
                    target="_blank"
                    rel="noreferrer"
                  />
                ),
              }}
            />
          </p>
        </div>
      }
    />
  );
});
